import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import StarField from '../components/StarField';
import { GalaxyMark, OrbitWordmark } from '../components/OrbitLogo';
import PhoneFrame from '../components/PhoneFrame';
import { toast } from 'sonner';

// Shown once, right after a brand-new user's magic link confirms and
// they have an authenticated session but no orbit_profiles row yet.
// Picks a real username/display name -- replaces the old Register
// screen (which asked for password + email up front instead).
export default function SetupProfile() {
  const nav = useNavigate();
  const { completeProfile } = useApp();
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const clean = username.trim().toLowerCase();
    if (clean.length < 3) { toast('Username must be at least 3 characters'); return; }
    if (!/^[a-z0-9_]+$/.test(clean)) { toast('Username: lowercase letters, numbers, underscores only'); return; }

    setSaving(true);
    try {
      await completeProfile(clean, displayName);
      toast('Your orbit is ready ✨');
      nav('/home', { replace: true });
    } catch (err) {
      setSaving(false);
      if (err.code === '23505' || /duplicate/i.test(err.message || '')) {
        toast('That username is already taken');
      } else {
        toast(err.message || 'Could not save profile');
      }
    }
  };

  const fieldStyle = { background: 'var(--lavender-input)', color: '#2a2540' };

  return (
    <PhoneFrame>
      <div className="relative min-h-full flex flex-col">
        <StarField gold={false} />
        <div className="relative z-10 flex-1 flex flex-col items-center px-8">
          <div className="floaty mt-16 mb-2"><GalaxyMark size={92} /></div>
          <div className="mb-2"><OrbitWordmark size={38} /></div>
          <p className="italic mb-6" style={{ color: '#d9cdeb' }}>You&apos;re in! Pick a username to finish.</p>

          <form onSubmit={submit} className="w-full max-w-sm space-y-4">
            <input style={fieldStyle} className="orbit-field placeholder:text-[#8a83a8]" placeholder="Username" value={username}
              onChange={(e) => setUsername(e.target.value.trim().toLowerCase())} autoFocus />
            <input style={fieldStyle} className="orbit-field placeholder:text-[#8a83a8]" placeholder="Display name (optional)" value={displayName}
              onChange={(e) => setDisplayName(e.target.value)} />
            <div className="relative flex justify-center pt-4">
              <span className="absolute bottom-1 w-44 h-20 rounded-full" style={{ background: 'radial-gradient(circle, rgba(240,180,60,.5), transparent 70%)', filter: 'blur(12px)' }} />
              <button type="submit" disabled={saving} className="press relative font-display orbit-primary-button" style={{
                fontSize: 20, padding: '12px 48px', opacity: saving ? 0.6 : 1,
              }}>{saving ? 'Building…' : 'Build my orbit'}</button>
            </div>
          </form>
        </div>
      </div>
    </PhoneFrame>
  );
}
